<template>
    <div class="dropdown">
        <button class="btn bmd-btn-fab bmd-btn-fab-sm dropdown-toggle" type="button" id="ex3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="flag-icon flag-icon-us" v-if="language == 'en_US'"></i>
            <i class="flag-icon flag-icon-fr" v-else-if="language == 'fr_FR'"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="ex3">
            <button class="dropdown-item" type="button" v-on:click="toggle" data-lang="en_US"><span class="flag-icon flag-icon-us"></span> English</button>
            <button class="dropdown-item" type="button" v-on:click="toggle" data-lang="fr_FR"><span class="flag-icon flag-icon-fr"></span> Français</button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "LanguageSelector",
        computed: {
            ...mapState("language", ["language"])
        },
        mounted: function() {
            // Fixing a bug between bootstrap and material design...
            $(this.$el).find("button").dropdown();
        },
        methods: {
            toggle: function(event) {
                let el = $(event.target);
                if (!el.hasClass("dropdown-item")) {
                    el = el.closest(".dropdown-item");
                }
                const lang = el.attr("data-lang");
                this.setLanguage(lang);
            },
            ...mapMutations("language", ["setLanguage"])
        }
    }
</script>

<style scoped>
    .dropdown {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .dropdown > button {
        background: #fff !important;
        width: 52px !important;
        height: 52px !important;
    }
    .dropdown > button > i {
        -webkit-box-shadow: 0px 0px 1px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px 0px 1px 0px rgba(0,0,0,0.75);
        box-shadow: 0px 0px 1px 0px rgba(0,0,0,0.75);
    }
    .dropdown button {
        cursor: pointer;
    }
    span {
        margin-top: -5px;
        margin-right: 10px;
    }
</style>
